export default function percentage(total, percentage) {
  if (percentage > 0) {
    return ((100 * percentage) / total).toFixed(2)
  } else {
    return 0
  }
}
